import React, { useState, useEffect } from 'react';
import { returnIntervalAvailable } from '../../utils/functions';
export default function HourIntervals({ gadgetApi, settings, cartAttributes, setCartAttributes, hourRef }) {
	const [selectedInterval, setSelectedInterval] = useState(cartAttributes.desiredTime);
	const [intervals, setIntervals] = useState([]);
	const [selectedDate, setSelectedDate] = useState(cartAttributes.desiredDate);

	useEffect(() => {
		setSelectedDate(cartAttributes.desiredDate);

		// Clear interval unavailable flag when user selects a new time
	}, [cartAttributes.desiredDate, cartAttributes.desiredTime, cartAttributes.intervalUnavailable]);

	useEffect(() => {
		let generatedIntervals = [];

		const generateIntervals = async () => {
			const intervalStart = parseInt(settings.intervalStart);
			const intervalEnd = parseInt(settings.intervalEnd);

			for (let hour = intervalStart; hour < intervalEnd; hour++) {
				const isLastHour = hour === intervalEnd - 1;

				const timeString = `${hour.toString().padStart(2, '0')}:00 - ${
					hour === 23 ? '00' : (hour + 1).toString().padStart(2, '0')
				}:00`;

				const timeValue = `${selectedDate}T${timeString}`.replaceAll(' ', '');

				const available =
					cartAttributes.deliveryMethod === 'delivery'
						? await returnIntervalAvailable(
								timeValue,
								gadgetApi,
								settings.maxPerHour,
								cartAttributes.cartToken
						  )
						: true;

				generatedIntervals.push({
					timeLabel: timeString,
					value: timeValue,
					available,
				});
			}
			setIntervals(generatedIntervals);
		};

		generateIntervals();
	}, [selectedDate, cartAttributes.deliveryMethod, selectedInterval]);

	useEffect(() => {
		if (
			selectedInterval &&
			intervals.find((interval) => interval.timeLabel === selectedInterval)?.available === false
		) {
			setSelectedInterval(null);
			setCartAttributes((prev) => ({
				...prev,
				desiredTime: null,
				intervalUnavailable: null,
				desiredTimePickedAt: null,
			}));
		}
	}, [intervals]);

	const handleIntervalSelect = async (interval) => {
		if (interval.available) {
			if (selectedInterval === interval.timeLabel) {
				setCartAttributes((prev) => ({
					...prev,
					desiredTime: null,
					intervalUnavailable: null,
					desiredTimePickedAt: null,
				}));

				return;
			} else {
				setSelectedInterval(interval.timeLabel);
				setCartAttributes((prev) => ({
					...prev,
					desiredTime: interval.timeLabel,
					intervalUnavailable: '',
					desiredTimePickedAt: new Date().toISOString(),
				}));
			}

			setTimeout(() => {
				const step3Element = document.querySelector('#step-3');
				
				if (step3Element) {
					step3Element.scrollIntoView({
						behavior: 'smooth',
						block: 'start',
					});
				}
			}, 300);
		}
	};

	useEffect(() => {
		const updateSelectedInterval = async () => {
			try {
				const existingInterval = await gadgetApi.selectedInterval.maybeFindFirst({
					filter: {
						cartToken: {
							equals: settings.cartToken,
						},
					},
				});

				if (existingInterval && cartAttributes.deliveryMethod == 'delivery') {
					await gadgetApi.selectedInterval.update(existingInterval.id, {
						value: `${cartAttributes.desiredDate}T${cartAttributes.desiredTime?.replaceAll(' ', '')}`,
						deliveryMethod: cartAttributes.deliveryMethod,
					});
				} else if (existingInterval && cartAttributes.deliveryMethod == 'pickup') {
					await gadgetApi.selectedInterval.delete(existingInterval.id);
				} else {
					await gadgetApi.selectedInterval.create({
						value: `${cartAttributes.desiredDate}T${cartAttributes.desiredTime}`,
						cartToken: settings.cartToken,
						deliveryMethod: cartAttributes.deliveryMethod,
					});
				}
			} catch (error) {
				console.error('Failed to update selected interval:', error);
			}
		};
		if (settings.cartToken) {
			updateSelectedInterval();
		}
	}, [settings.cartToken, cartAttributes.deliveryMethod, cartAttributes.desiredDate, cartAttributes.desiredTime]);

	return (
		<div className="hour-intervals" ref={hourRef}>
			<div className="hour-intervals__buttons">
				{intervals.map((interval, index) => (
					<button
						key={index}
						className={`hour-intervals__button ${
							cartAttributes?.desiredTime === interval.timeLabel && !cartAttributes.intervalUnavailable
								? 'hour-intervals__button--selected'
								: ''
						} ${!interval.available ? 'hour-intervals__button--disabled' : ''}`}
						onClick={() => interval.available && handleIntervalSelect(interval)}
						disabled={!interval.available}
					>
						{interval.timeLabel}
					</button>
				))}
			</div>
		</div>
	);
}
